export default "/_next/static/chunks/stacy.texture.84da32e0b941a997c0846909034f9169.glb";